import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Media } from 'reactstrap';
import { Scrollbars } from 'react-custom-scrollbars';
import defaultLogo from '../../../assets/img/users/default-user-image.png';

class HeaderNotificationComponent extends React.Component {

  	createMarkup = (title) => {
		return (
	  		title.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, "").substr(0, 50) + '...'
	  	)
	}

	render() {

		if (this.props.notifications && this.props.notifications.length ) {
			return (
				 <Scrollbars style={{ width: 250, height: 250 }}>
					{
						this.props.notifications.map((notification) => (
							<Link 
								key={notification.id} 
								to={`/thong-bao/${notification.id}/chi-tiet-thong-bao.html`}
							>
						      	<Media className="pb-2">
							        <Media left className="align-self-center pr-3">
							        	<img src={ this.props.website_logo ? this.props.website_logo : defaultLogo } alt="Avatar" className="rounded-circle media-object" style={{ width: 40, height: 40 }} />
							        </Media>
							        <Media body middle className="align-self-center">
							        	{
						        			this.createMarkup(notification.title)
						        		}
							        </Media>
							        <Media right className="align-self-center" style={{ width: 60 }} >
							          	<small className="text-muted">{ notification.text_created_at }</small>
							        </Media>
						      	</Media>
					      	</Link>
					    ))
					}
				</Scrollbars>
			)
	    } else {
	    	return (
	    		<div className="text-center text-danger">
	    			Không có thông báo mới
    			</div>
    		)
	    }
	}

}

const mapStateToProps = (state) => {
  return {
	    notifications: state.user.notifications,
	    unread_notification: state.user.unread_notification,
	    website_logo: state.configSystem.config.website_logo,
	}
}

export default connect(mapStateToProps)(HeaderNotificationComponent);